import smallBall from '../../../assets/images/production/analyticalModeling/ball-s.png'
import ball from '../../../assets/images/production/analyticalModeling/ball.png'
import taosha from '../../../assets/images/production/analyticalModeling/taosha.png'
import leftBall from '../../../assets/images/production/analyticalModeling/left-ball.png'

import styles from './style.module.scss'

function AnalyticalModelingTools() {
    return (
        <div className={`production-introduction-wrapper ${styles['analytical-model-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">大数据智能化产品</div>
                <div className={`content ${styles['content']}`}>烽火星空大数据智能化系列产品作为行业解决方案的核心技术支撑，主要包括大数据平台、数据治理工具、分析建模工具、应用开发工具，贯穿数据的存算、分析、应用、展示全生命周期，是新时代信息领域的“大国重器”</div>
            </div>
            <div className={styles['analytical-model-container']}>
                <div className={`introduction-container ${styles['introduction-container']}`}>
                    <p>产品简介<img src={smallBall} alt="" /></p>
                    <div className={`introduction-title ${styles['introduction-title']}`}>
                        <div className={`title-wrapper ${styles['title-wrapper']}`}>
                            <img src={leftBall} alt="" />
                            <div className={`title-container ${styles['title-container']}`}>
                                <div>
                                    <p><span>淘沙</span><span>—— 分析建模工具</span></p>
                                    <p>分析建模工具立足于不同的业务分析场景，用户仅需通过拖、拉、拽的画布设计操作，即可对千人千面的业务思路进行精细刻画，实现传统业务思路向数据分析模型的轻松转化，从而助力各行业数据价值的快速变现。</p>
                                </div>
                                <img src={taosha} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles['feature-container']}>
                    <p>产品特色</p>
                    <div className={styles['feature-content']}>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <p>场景化的业务模型，让模型使用更简单</p>
                            <p>内置13大类300+海量数据分析模型，涵盖数据查询、时空分析、通联分析、主题分析等常用业务分析场景，能够满足公安、政务、海关等行业需求。此外，用户也可按需自行搭建业务模型，从而满足复杂变化的业务需求。</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <p>智能化的算子推荐，让建模思路更灵活</p>
                            <p>为满足用户业务建模过程中存在的基础、高级、专业不同层级需求，大数据建模平台提供基础算子、高级算子、业务算子500余个，为用户业务逻辑的表达提供更加自如的设计空间。</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <p>可视化的建模设计，让建模过程更便捷</p>
                            <p>提供了一个自定义建模分析的设计平台，在平台上通过各类可视化组件的拖拽和逻辑设计，以流程化的模式实现对数据的分析和挖掘。</p>
                        </div>
                        <div className={`feature-item ${styles['feature-item']}`}>
                            <p>开放化的模型社区，让成熟模型可积淀</p>
                            <p>提供一个模型案例分享、行业知识学习和业务思路交流的平台，为用户积累案例知识、创新业务思路提供无限可能。</p>
                        </div>
                    </div>
                    <img src={ball} alt="" />
                </div>
            </div>
        </div>
    )
}

export default AnalyticalModelingTools